<template>
  <div>
    <h1 id="montserrat">{{ designName }}</h1>
    <br />
    <br />
    <br />
    <b-container class="bv-example-row">
      <b-row align-h="start">
        <b-col class="font-toolbar-left-col">
          <ul class="nav nav-tabs">
            <!-- Loop through all pages and build out all the tabs -->
            <li class="nav-item" :key="page.design_page_id" v-for="page in pages">
              <router-link
                class="textdecorationnone"
                :to="'/editor/designs/'+page.design_id+'?pageID='+page.design_page_id"
              >
                <!-- If this is the active tab -->
                <a
                  v-if="page.design_page_id === currentPageID"
                  class="nav-link active"
                  href="javascript:void(0);"
                >
                  <EditableText
                    @modified="updatePageName"
                    :parentid="page.design_page_id"
                    :value="page.page_name"
                  ></EditableText>
                </a>

                <!-- If this is NOT the active tab -->
                <a
                  v-if="page.design_page_id !== currentPageID"
                  class="nav-link"
                  href="#"
                >{{page.page_name}}</a>
              </router-link>
            </li>

            <!-- Add New Page tab -->
            <li class="nav-item" v-if="pagesLoaded">
              <div>
                <a class="nav-link" v-b-modal.add-page-modal>+ Add New</a>
                <b-modal
                  id="add-page-modal"
                  centered
                  size="lg"
                  title="Add a page to your design!"
                  hide-footer
                >
                  <AddPage
                    @uploadSuccess="pageAdded"
                    @cancelClick="togglePageModal"
                    :designID="designID"
                  ></AddPage>
                </b-modal>
              </div>
            </li>
          </ul>
          <br />
          <!-- Different CanvasEditor for each page -->
          <div :key="page.design_page_id" v-for="page in pages">
            <CanvasEditor
              v-if="page.design_page_id === currentPageID"
              :page="page"
              :designID="designID"
              :canvasJSON="canvasJSONMap.get(page.design_page_id)"
              :images="images"
              @modified="updateCanvasJSON"
            ></CanvasEditor>
          </div>
          <!-- <div :key="page.design_page_id+'2'" v-for="page in pages">
            <br />
            <CanvasEditor2
              v-if="page.design_page_id === currentPageID"
              :page="page"
              :canvasJSON="canvasJSONMap.get(page.design_page_id)"
            ></CanvasEditor2>
          </div>-->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import CanvasEditor from "./CanvasEditor.vue";
// import CanvasEditor2 from "./CanvasEditor2.vue";
import EditableText from "./EditableText.vue";
import AddPage from "./AddPage.vue";
// import draggable from "vuedraggable";

export default {
  name: "DesignEditor",
  components: {
    CanvasEditor,
    // CanvasEditor2,
    AddPage,
    EditableText,
    // draggable,
  },
  data() {
    return {
      pages: [],
      currentPage: null,
      currentPageID: null,
      canvasJSONMap: new Map(),
      pagesLoaded: false,
      designID: null,
      designName: "",
      images: [],
    };
  },
  methods: {
    togglePageModal() {
      this.$root.$emit("bv::toggle::modal", "add-page-modal");
    },
    pageAdded(page) {
      this.pages.push(page);

      this.$root.$emit("bv::hide::modal", "add-page-modal");
      this.$router.push({
        path: "/editor/designs/".concat(this.designID),
        query: { pageID: page.design_page_id },
      });
    },
    changePage() {
      var pageID = this.$route.query.pageID;
      this.changePageToPageID(pageID);
    },
    changePageToPageID(pageID) {
      console.log("changePageToPageID pageID:", pageID);
      if (this.pages.length == 0 && pageID !== undefined) {
        this.$router.push({ path: "/editor/designs/".concat(this.designID) });
        return;
      }

      if (pageID !== undefined) {
        // console.log("pageID", pageID);
        var i;
        for (i = 0; i < this.pages.length; i++) {
          var page = this.pages[i];
          if (page.design_page_id === pageID) {
            this.currentPageID = pageID;
            break;
          }
        }

        if (!this.currentPageID) {
          this.$router.push({
            path: "/editor/designs/".concat(this.designID),
          });
          return;
        }
      } else {
        this.currentPageID = this.pages[0].design_page_id;
      }
    },
    updateCanvasJSON(pageID, json) {
      //   console.log("parent JSON", pageID, json);
      this.canvasJSONMap.set(pageID, json);
      axios
        .patch(
          process.env.VUE_APP_API_SERVER.concat(
            "/v1/designs/",
            this.designID,
            "/pages/",
            pageID
          ),
          {
            canvas_json: json,
          }
        )
        .then(() => {
          console.log("changes saved");
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          // Sleep for 10ms to give the loading icon a chance to show up
          setTimeout(() => {
            this.loading = false;
          }, 50);
        });
    },
    updatePageName(pageID, pageName) {
      console.log("pageID:", pageID, "pageName:", name);
      if (!pageName || pageName === "") {
        return;
      }
      console.log("pageID:", pageID, "pageName:", pageName);
      var i;
      for (i = 0; i < this.pages.length; i++) {
        if (this.pages[i].design_page_id == pageID) {
          this.pages[i].page_name = pageName;
        }
      }
      axios
        .patch(
          process.env.VUE_APP_API_SERVER.concat(
            "/v1/designs/",
            this.designID,
            "/pages/",
            pageID
          ),
          {
            page_name: pageName,
          }
        )
        .then(() => {
          console.log("changes saved");
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          // Sleep for 10ms to give the loading icon a chance to show up
          setTimeout(() => {
            this.loading = false;
          }, 50);
        });
    },
  },

  watch: {
    "$route.query.pageID": function () {
      this.changePage();
    },
  },

  mounted() {
    this.designID = this.$route.params.design_id;

    // Make API call
    axios
      .get(process.env.VUE_APP_API_SERVER.concat("/v1/designs/", this.designID))
      .then((resp) => {
        this.pages = resp.data.data.pages;
        this.designName = resp.data.data.design_name;

        var i;
        for (i = 0; i < this.pages.length; i++) {
          var page = this.pages[i];
          this.canvasJSONMap.set(page.design_page_id, page.canvas_json);
        }

        console.log("finished setting json");

        this.changePage();
      })
      .catch((err) => {
        alert(err);
      })
      .finally(() => {
        // Sleep for 50ms to give the loading icon a chance to show up
        setTimeout(() => {
          this.loading = false;
          this.pagesLoaded = true;
        }, 50);
      });

    // Get images for user
    axios
      .get(process.env.VUE_APP_API_SERVER.concat("/v1/images/"))
      .then((resp) => {
        this.images = resp.data.data;
      })
      .catch((err) => {
        alert(err);
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.textdecorationnone {
  text-decoration: none !important;
}
</style>
